import Relay from 'react-relay';

export default class EnqueueMonthlyTariffClickUpAllJob extends Relay.Mutation {
    static propTypes = {};

    getMutation() {
        return Relay.QL`mutation { enqueueMonthlyTariffClickUpAllJob }`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on EnqueueMonthlyTariffClickUpAllJobPayload {
                job { id, realId, name }
            }
        `;
    }

    getConfigs() {
        return [{ type: 'REQUIRED_CHILDREN', children: [this.getFatQuery()] }];
    }

    getVariables() {
        return { confirm: true };
    }
}


